import axios from "axios";
import { BASE_URL } from "../constants";

export const signIn = ({ username, password }) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/auth/signIn",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
    },
    data: JSON.stringify({ username, password }),
  });
};

export const userProfile = (token) => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-profile", // for android use
    headers: {
      Authorization: "Bearer " + token,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Content-Type": "application/json",
    },
  });
};